module.exports = __webpack_public_path__ + "static/img/icon_home.fb862029.svg";